
export default localStorage.getItem('auth') || false
